module.exports = __webpack_public_path__ + "static/media/logo-ioasys-login.88f49b2c.svg";